import { Button, Dialog, DialogActions, DialogContent, Typography } from '@/ui';

import type { Session } from '@/types';
import type { FC } from 'react';

interface ProviderAwareSessionActionProps {
  action: 'cancel' | 'reschedule';
  close?: () => void;
  session: Pick<Session, 'isChemistryCall' | 'kind'>;
}

const ProviderAwareSessionAction: FC<ProviderAwareSessionActionProps> = ({
  action,
  close,
  session,
}) => {
  const isChemistryCall =
    session.kind === 'chemistry' ||
    (!session.kind && session.isChemistryCall === true);
  let sessionLabel = 'session';
  if (isChemistryCall) sessionLabel = 'Chemistry Call';
  else if (session.kind === 'biweekly' || session.kind === 'single')
    sessionLabel = 'coaching session';

  return (
    <Dialog open onClose={close}>
      <DialogContent>
        <Typography className="mb-2" variant="h6">
          This session was booked through Mento.
        </Typography>
        <Typography variant="body1">
          Cal.com {action} links are not available for this {sessionLabel}.
          Please contact support if you need to {action} this session.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProviderAwareSessionAction;
